import OpponentSelect from './OpponentSelect';

export default OpponentSelect;
